// extracted by mini-css-extract-plugin
module.exports = {"apps-flyer-banner_sticky":"AppsFlyerBanner_apps-flyer-banner_sticky__Ocxzj","apps-flyer-banner":"AppsFlyerBanner_apps-flyer-banner__FHZeq"};